/* eslint-disable no-shadow, no-loop-func*/

/**
*  Rich Content on product detail page
*
*  - the floor is async, so when the floor is not empty (#ConceptionHistoryFloor) we download the Brightcove script (loadVideoLibrary)
*  - then we init the video (initVideos) with the Brightcove script and we init other components
*
*/
import {getScript} from '@/commons/utils';

const hotspots = [];

// player configuration
const playerData = {
  accountId: cube.config.brightcove_accountId,
  playerId: cube.config.brightcove_playerId,
};

const scriptURL = `https://players.brightcove.net/${playerData.accountId}/${playerData.playerId}_default/index.min.js`;

export function init() {
  const initHotspotRichContent = () => {
    getScript(scriptURL).then(() => {
      initVideos();
      cube.event.on('async-content:loaded', initVideos);
    });

    initHotspotsPosition();
    initHotspotsInteraction();
    initGalleries();
    initCollapse();
  };

  if (cube.$id('ConceptionHistoryFloor')) initHotspotRichContent();
  cube.event.on('async-content:ConceptionHistoryFloor',initHotspotRichContent);

  bindResize();
}

function getContext() {
  if(cube.ui.isMobile())
    return 'MOBILE';
  else if (cube.ui.isTablet())
    return 'TABLET';
  return 'DESKTOP';
}

function initCollapse(){
  // cartridge loaded
  const btnCollapse = $('.cube-rich-content .btn-collapse');
  btnCollapse.attr('aria-expanded', 'false');

  // event listener for button collapse
  btnCollapse.on('click.collapse-toggle', (event) => {
    event.preventDefault();
    $(event.currentTarget).attr('aria-expanded', ($(event.currentTarget).attr('aria-expanded') !== 'true'));
    $(event.currentTarget).parent().find('.collapse:first').collapse('toggle');
  });
}

//Init interactions when resizing width
function bindResize() {
  cube.event.on('resize-width', cube.debounce(() => {
    initHotspotsInteraction();
    initGalleries();
  }, 75));
}

// init Video elements
function initVideos() {
  cube.$$('.dkt-video video.video-js').forEach(video => {
    if (window.bc) window.bc(video);

    video.onclick = event => {
      const videoFloor = event.currentTarget.closest('.floor');
      videoFloor.$$('.dkt-content-container, .vjs-big-play-button').classList.add('clicked');
    };
  });
}

/**
   * Positioning the hotspots
   * Hotspot are positioned by data ratio given in HTML parameter and convert into percentage
   * Infos display class are added to display infos on the right position
   */
function initHotspotsPosition() {
  const LEFT_MAX = 63;
  const TOP_MIN = 25;
  const TOP_MAX = 75;

  const mediaFullHotspot = document.querySelectorAll('.dkt-hotspot-container');

  mediaFullHotspot.forEach(elt => {
    hotspots.push(...elt.$$('.dkt-hotspot'));

    hotspots.forEach (hotspot => {
      const top = hotspot.dataset.verticalposition;
      const left = hotspot.dataset.horizontalposition;

      // Display the hotspot according to the data position given (17px are removed to center the hotspot button)
      hotspot.style.top = `calc(-1.7rem + ${top}%)`;
      hotspot.style.left = `calc(-1.7rem + ${left}%)`;
      hotspot.style.display = 'block';

      // Set the hotspot info display depending of the hotspot position
      if (top < TOP_MIN) {
        if (left > LEFT_MAX) hotspot.classList.add('dkt-infos-origin-top-left');
        else hotspot.classList.add('dkt-infos-origin-top-right');
      }

      if (top >= TOP_MIN && top <= TOP_MAX) {
        if (left > LEFT_MAX) hotspot.classList.add('dkt-infos-origin-center-left');
        else hotspot.classList.add('dkt-infos-origin-center-right');
      }

      if (top > TOP_MAX) {
        if (left > LEFT_MAX) hotspot.classList.add('dkt-infos-origin-bottom-left');
        else hotspot.classList.add('dkt-infos-origin-bottom-right');
      }
    });
  });
}

/**
 * Init hotspot interaction
 * Mobile context : react on click and display infos in a container under hotspot-media-container
 * Desktop context : react on mouse enter or leave and add class 'active'
 * @param {*} context
 */
function initHotspotsInteraction() {
  let button = null;
  switch (getContext()) {
    case 'MOBILE' :
      hotspots.forEach (hotspot => {
        button = hotspot.$('.dkt-hotspot-button');
        hotspot.onmouseleave = null;
        hotspot.onmouseenter = null;

        const infoContainer = hotspot.closest('.floor').querySelector('.dkt-mobile.dkt-infos-container');

        button.onclick = () => {

          if(hotspot.classList.contains('dkt-active')){
            infoContainer.classList.remove('dkt-visible');
            infoContainer.innerHTML = null;
          }
          else {
            infoContainer.classList.add('dkt-visible');

            infoContainer.innerHTML = hotspot.querySelector('.dkt-infos').innerHTML;
            cube.lazyload.init('.dkt-mobile.dkt-infos-container');

            hotspots.forEach(element => {
              element.classList.remove('dkt-active');
            });
          }
          hotspot.classList.toggle('dkt-active');
        };
      });
      break;

    case 'TABLET' :

      hotspots.forEach (hotspot => {
        button = hotspot.querySelector('.dkt-hotspot-button');
        hotspot.onmouseleave = null;
        hotspot.onmouseenter = null;
        button.onclick = null;

        hotspot.onclick = event => {
          const hotspotButton = event.currentTarget;

          if(hotspotButton.classList.contains('dkt-active'))
            hotspotButton.classList.remove('dkt-active');
          else{
            hotspots.forEach(element => {
              element.classList.remove('dkt-active');
            });
            hotspotButton.classList.add('dkt-active');
          }
        };
      });
      break;


    default :
      hotspots.forEach (hotspot => {
        button = hotspot.querySelector('.dkt-hotspot-button');
        button.onclick = null;
        hotspot.classList.remove('dkt-active');

        hotspot.onmouseleave = () => {
          hotspot.classList.remove('dkt-active');
        };

        hotspot.onmouseenter = () => {
          hotspot.classList.add('dkt-active');
        };
      });
  }
}

//Gallery Brick Slick Functions
const GALLERY = {

  slickon:() => {
    $('.dkt-grid-row').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      rows:2,
      dots: true,
      infinite:true,
      focusOnSelect: true,
      prevArrow: false,
      nextArrow: false
    });
  },

  slickoff: () => {
    $('.dkt-grid-row').slick('unslick');
  }
};

/**
* Init gallery depending on context
* Mobile context : Display slider
* Desktop context : Display only one grid
* @param {*} context
*/
function initGalleries(){
  const context = getContext();
  if(context === 'MOBILE' && !$('.dkt-grid-row').hasClass('slick-initialized')){
    $('.dkt-grid-row .dkt-title-container').remove();
    GALLERY.slickon();
  }else if($('.dkt-grid-row').hasClass('slick-initialized')){
    GALLERY.slickoff();
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/rich-content.js